import Axios from 'axios';

// Сохраняем заголовки запроса в локальной переменной
const AxiosClient = Axios.create();


export default AxiosClient;
